import {privateApi} from 'utils/api'

export const filterApplyPOS = async (payload: any) =>
    await privateApi.get('cps/v1/airline-dashboard/point-of-sales', {params: payload})
export const filterApplyTL = async (payload: any) =>
    await privateApi.get('cps/v1/airline-dashboard/top-lanes', {params: payload})
export const filterApplyTC = async (payload: any) =>
    await privateApi.get('cps/v1/airline-dashboard/top-commodities', {params: payload})
export const filterApplyTP = async (payload: any) =>
    await privateApi.get('cps/v1/airline-dashboard/top-products', {params: payload})
export const filterApplyTA = async (payload: any) =>
    await privateApi.get('cps/v1/airline-dashboard/top-accounts', {params: payload})
export const filterApplyDI = async (payload: any) =>
    await privateApi.get('cps/v1/airline-dashboard/domestic-international', {params: payload})
